import {
    AD_REQUEST,
    AD_ERROR,
    FETCH_ADS_SUCCESS,
    CREATE_AD_SUCCESS,
    UPDATE_AD_SUCCESS,
    DELETE_AD_SUCCESS
} from "./actions";

const initialState = {
    ads: [],
    loading: false,
    error: null
};

export default function adReducer(state = initialState, action) {
    switch (action.type) {
        case AD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case AD_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case FETCH_ADS_SUCCESS:
            return {
                ...state,
                loading: false,
                ads: action.payload
            };

        case CREATE_AD_SUCCESS:
            return {
                ...state,
                loading: false,
                ads: [...state.ads, action.payload]
            };

        case UPDATE_AD_SUCCESS:
            return {
                ...state,
                loading: false,
                ads: state.ads.map(ad =>
                    ad._id === action.payload._id ? action.payload : ad
                )
            };

        case DELETE_AD_SUCCESS:
            return {
                ...state,
                loading: false,
                ads: state.ads.filter(ad => ad._id !== action.payload)
            };

        default:
            return state;
    }
}

